/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *  Add Multiple Triggers
 *   
 */


class GoCart {

  constructor(options) {

      const defaults = {
          cartModalFail: '.js-go-cart-modal-fail',
          cartModalFailClose: '.js-go-cart-modal-fail-close',
          cartModal: '.js-go-cart-modal',
          cartModalClose: '.js-go-cart-modal-close',
          cartModalContent: '.js-go-cart-modal-content',
          cartDrawer: '.js-go-cart-drawer',
          cartDrawerContent: '.js-go-cart-drawer-content',
          cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
          cartDrawerFooter: '.js-go-cart-drawer-footer',
          cartDrawerClose: '.js-go-cart-drawer-close',
          cartMiniCart: '.js-go-cart-mini-cart',
          cartMiniCartContent: '.js-go-cart-mini-cart-content',
          cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
          cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
          cartTrigger: '.js-go-cart-trigger',
          cartOverlay: '.js-go-cart-overlay',
          cartCount: '.js-go-cart-counter',
          addToCart: '.js-go-cart-add-to-cart',
          removeFromCart: '.js-go-cart-remove-from-cart',
          removeFromCartNoDot: 'js-go-cart-remove-from-cart',
          itemQuantity: '.js-go-cart-quantity',
          itemQuantityPlus: '.js-go-cart-quantity-plus',
          itemQuantityMinus: '.js-go-cart-quantity-minus',
          cartCheckout: '.js-go-checkout__button',
          cartMode: 'drawer',
          drawerDirection: 'right',
          displayModal: false,
					fetchCartComplete: 'fetch-cart-complete',
          // eslint-disable-next-line no-template-curly-in-string
          moneyFormat: '${{amount}}',
          labelAddedToCart: 'was added to your cart.',
          labelCartIsEmpty: 'Your Cart is currently empty!',
          labelQuantity: 'Quantity:',
          labelRemove: 'Remove',
          cartCountNum : '.cart-count-num',
          // Variants 
          goCartItemVariant: ".js-go-cart-item__variant",
      };

      this.defaults = Object.assign({}, defaults, options);

      this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
      this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
      this.cartModal = document.querySelector(this.defaults.cartModal);
      this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
      this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
      this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
      this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
      this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
      this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
      this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
      this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
      this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
      this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
      this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
      this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
      this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
      this.cartCount = document.querySelector(this.defaults.cartCount);
      this.addToCart = document.querySelectorAll(this.defaults.addToCart);
      this.removeFromCart = this.defaults.removeFromCart;
      this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
      this.itemQuantity = this.defaults.itemQuantity;
      this.itemQuantityPlus = this.defaults.itemQuantityPlus;
      this.itemQuantityMinus = this.defaults.itemQuantityMinus;
      this.cartMode = this.defaults.cartMode;
      this.drawerDirection = this.defaults.drawerDirection;
      this.displayModal = this.defaults.displayModal;
      this.moneyFormat = this.defaults.moneyFormat;
      this.labelAddedToCart = this.defaults.labelAddedToCart;
      this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
      this.labelQuantity = this.defaults.labelQuantity;
      this.labelRemove = this.defaults.labelRemove;
      this.cartCountNum = this.defaults.cartCountNum;
      this.goCartItemVariant = this.defaults.goCartItemVariant;
      this.cartCheckout = document.querySelector(this.defaults.cartCheckout);

      this.init();

  }

  get isDrawerMode() {
      return this.cartMode === 'drawer';
  }

  init() {
			this.createCustomEmitter();
      this.fetchCart();

      if (this.isDrawerMode) {
          this.setDrawerDirection();
      }

      document.addEventListener('click', (event) => {
          if (event.target.matches(this.defaults.addToCart)) {
              event.preventDefault();
              let item = event.target;
              let form = item.parentNode;
              while ('form' !== form.tagName.toLowerCase()) {
                  form = form.parentNode;
              }
              const formID = form.getAttribute('id');
              this.addItemToCart(formID);
          }
      }, false);

    
           // -----------//  
          this.addToCart.forEach((item) => {
          item.addEventListener('click', (event) => {
          event.preventDefault(); 
              let item = event.target;
              let form = item.parentNode;
              while ('form' !== form.tagName.toLowerCase()) {
                  form = form.parentNode;
              }
              const formID = form.getAttribute('id');
              this.addItemToCart(formID); 
          });
          }); 
          // -------------//
    
      this.cartTrigger.forEach((item) => {
          item.addEventListener('click', (evt) => {
              evt.preventDefault();
              if (this.isDrawerMode) {
                  this.openCartDrawer();
              } else {
                  this.openMiniCart();
              }
              this.openCartOverlay();
          });
      });


      this.cartOverlay.addEventListener('click', () => {
          this.closeFailModal();
          this.closeCartModal();
          if (this.isDrawerMode) {
              this.closeCartDrawer();
          } else {
              this.closeMiniCart();
          }
          this.closeCartOverlay();
      });

      if (this.isDrawerMode) {
          this.cartDrawerClose.addEventListener('click', () => {
              this.closeCartDrawer();
              this.closeCartOverlay();
          });
      }

      if (this.displayModal) {
          this.cartModalClose.forEach((item) => {
              item.addEventListener('click', () => {
                  this.closeFailModal();
                  this.closeCartModal();
                  if (this.isDrawerMode) {
                      this.closeCartDrawer();
                  } else {
                      this.closeMiniCart();
                  }
                  this.closeCartOverlay();
              });
          });
      }

      if (this.cartCheckout) { 
        this.cartCheckout.addEventListener('click', (event) => { 
            event.preventDefault()

            this.redirectToReChargeCheckout()
        })
      }

      this.cartModalFailClose.addEventListener('click', () => {
          this.closeFailModal();
          this.closeCartModal();
          if (this.isDrawerMode) {
              this.closeCartDrawer();
          } else {
              this.closeMiniCart();
          }
          this.closeCartOverlay();
      });

  }

  fetchCart(callback) {
      window.fetch('/cart?view=json', { 
          method: 'GET',
          credentials: 'same-origin',
      })
          .then((response) => response.text())
          .then((cart) => { 
						eval(cart); 
						this.fetchHandler(window.cart, callback); 
						document.dispatchEvent(this.fetchCartComplete);
					})
          .catch((error) => {
              console.error(error);
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  addItemToCart(formID) {
      const form = document.querySelector(`#${formID}`);
      const formData = serialize(form, {hash: true});
      window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
      })
          .then((response) => response.json())
          .then((product) => this.addItemToCartHandler(product))
          .catch((error) => {
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  removeItem(line) {
      const quantity = 0;
      window.fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({quantity, line}),
          headers: {
              'Content-Type': 'application/json',
          },
      })
          .then((response) => response.json())
          .then(() => this.fetchCart())
          .catch((error) => {
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  redirectToReChargeCheckout() { 
    if ( window.cart && ! window.cart.has_subscription_products ) {
        // Using old primal's redirect to get auto discount code to be applied
        SubscriptionManager.saveCartAndRedirect()
        return
    }

    var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?',
        url_params = [
            'myshopify_domain=' + Shopify.shop,
        ],
        cart_token = [],
        ga_linker = [];

    try {
        cart_token = ['cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2]]
        ga_linker = [ga.getAll()[0].get('linkerParam')]
    } catch (e) { 
    }

    url_params = url_params.concat(cart_token).concat(ga_linker)

    window.location.href = checkout_url + url_params.join('&')
  }

  changeItemQuantity(line, quantity) {
      window.fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({quantity, line}),
          headers: {
              'Content-Type': 'application/json',
          },
      })
          .then((response) => response.json())
          .then(() => this.fetchCart())
          .catch((error) => {
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  swapOutVariants(currentVariant, newVariant, currentQty) {
    window.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: { [currentVariant]: 0, [newVariant]: currentQty }}),
    })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
          this.ajaxRequestFail();
          throw new Error(error);
      });
  }

  cartItemCount(cart) {
      this.cartCount.innerHTML = cart.item_count;
  }

  updateShippingBar(cart) {
    if ( document.getElementsByClassName("cart-free-shipping-wrapper").length > 0 ) {
      document.querySelector(".cart-free-shipping-wrapper").remove();
    }
    let shippingBarWidth = 0,
        shippingBarText = "";
    if (cart.total_price >= window.shipping_threshold*100) {
      shippingBarWidth=100;
      shippingBarText = 'FREE US SHIPPING';
    } else {
      var tillFreeShipping = (window.shipping_threshold*100) - parseInt(cart.total_price);
      shippingBarWidth = parseInt(cart.total_price/(window.shipping_threshold*100)*100);
      shippingBarText = 'You are $' + parseFloat(tillFreeShipping / 100) + ' away from free US standard shipping.';
    }

    const shippingBarHTML = `
      <div class="cart-free-shipping-wrapper">
        <div class="cart-free-shipping">
          <span style="width: ${shippingBarWidth}%;"></span>
        </div>

        <p class="cart-more-shipping">
          ${shippingBarText}
        </p>
      </div>
    `;
    document.querySelector(".cart-shipping-bar").insertAdjacentHTML("afterbegin", shippingBarHTML);
  }

  updateCartCountHeader(cart) {
    document.querySelector(this.cartCountNum).innerHTML=cart.item_count;
  }

	createCustomEmitter() {
		var detail = 'Cart Has Completed Fetching';
		try {
			// For modern browsers except IE:
			this.fetchCartComplete = new CustomEvent(this.defaults.fetchCartComplete, {detail:detail, bubbles: true});
		} catch(err) {
		
			// If IE 11 (or 10 or 9...?) do it this way:
			// Create the event.
			this.fetchCartComplete = document.createEvent('Event');
			this.fetchCartComplete.initEvent(this.defaults.fetchCartComplete, true, true);
			this.fetchCartComplete.detail = detail;
		}
	}

  fetchAndOpenCart() {
      this.fetchCart(() => {
          if (this.isDrawerMode) {
              this.openCartDrawer();
          } else {
              this.openMiniCart();
          }
          this.openCartOverlay();
      });
  }

  fetchAndOpenModal(product) {
      this.fetchCart(() => {
          this.renderCartModal(product);
          this.openCartModal();
          this.openCartOverlay();
      });
  }

  fetchHandler(cart, callback) {
      this.cartItemCount(cart);
      if ( window.allow_shipping_threshold ){
       this.updateShippingBar(cart); 
      }
      this.updateCartCountHeader(cart);
      if (this.isDrawerMode) {
          if (cart.item_count === 0) {
              this.renderBlankCartDrawer();
              this.cartDrawerFooter.classList.add('is-invisible');
          } else {
              this.renderDrawerCart(cart);
              document.querySelector(".cart-shipping-bar .go-cart__button").classList.remove('is-invisible');
              this.cartDrawerFooter.classList.remove('is-invisible');
              if ((typeof callback) === 'function') {
                  callback(cart);
              }
          }
      } else if (cart.item_count === 0) {
          this.renderBlankMiniCart();
          this.cartMiniCartFooter.classList.add('is-invisible');
      } else {
          this.renderMiniCart(cart);
          this.cartMiniCartFooter.classList.remove('is-invisible');
          if ((typeof callback) === 'function') {
              callback(cart);
          }
      }
  }

  addItemToCartHandler(product) {
      return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
  }

  ajaxRequestFail() {
      this.openFailModal();
      this.openCartOverlay();
  }

  renderCartModal(product) {
      this.clearCartModal();
      let productVariant = product.variant_title;
      if (productVariant === null) {
          productVariant = '';
      } else {
          productVariant = `(${productVariant})`;
      }
      const cartSingleProduct = `
      <div class="go-cart-modal-item">
          <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
          <div class="go-cart-item__info">
              <a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a> ${this.labelAddedToCart}
          </div>
      </div>
    `;
      this.cartModalContent.innerHTML += cartSingleProduct;
  }

  renderDrawerCart(cart) {
      this.clearCartDrawer();
      cart.items.forEach((item, index) => {
          const cartSingleProduct = `
      <div class="go-cart-item__single" data-line="${Number(index + 1)}">
          <div class="go-cart-item__info-wrapper">
              <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
              <div class="go-cart-item__info">
                  <a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>
                  <div class="go-cart-item__variants-container">
                      <div class="go-cart-item__variant js-go-cart-item__variant" data-original-var-id="${item.id}" data-quantity="${item.quantity}" data-new-var-id="${item.variant_id}">
                          <div class="go-cart-item__dots selected"></div>
                          ${item.variant_title}
                      </div>
                  </div>
                  <div class="go-cart-item__quantity">
                    <span class="go-cart-item__quantity-label visuallyhidden">${this.labelQuantity}</span>
                    <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                    <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                    <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                  </div>
              </div>
          </div>
          <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
          <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
      </div>
    `;
          this.cartDrawerContent.innerHTML += cartSingleProduct;
      });
      this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
      this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
      const removeFromCart = document.querySelectorAll(this.removeFromCart);
      removeFromCart.forEach((item) => {
          item.addEventListener('click', () => {
              GoCart.removeItemAnimation(item.parentNode);
              const line = item.parentNode.getAttribute('data-line');
              this.removeItem(line);
          });
      });
      const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
      itemQuantityPlus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
              this.changeItemQuantity(line, quantity);
          });
      });
      const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
      itemQuantityMinus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
              this.changeItemQuantity(line, quantity);
              if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                  GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode);
              }
          });
      });

      const goCartItemVariant = document.querySelectorAll(this.goCartItemVariant);
      goCartItemVariant.forEach((item) => {
        item.addEventListener('click', () => {
          const originalVariantId = item.getAttribute("data-original-var-id");
          const newVariantId = item.getAttribute("data-new-var-id");
          const quantity = item.getAttribute("data-quantity");
          if(originalVariantId != newVariantId) {
            this.swapOutVariants(originalVariantId, newVariantId, quantity);
          }
        });
      });

  }

  renderMiniCart(cart) {
      this.clearMiniCart();
      cart.items.forEach((item, index) => {
          let itemVariant = item.variant_title;
          if (itemVariant === null) {
              itemVariant = '';
          }
          const cartSingleProduct = `
      <div class="go-cart-item__single" data-line="${Number(index + 1)}">
          <div class="go-cart-item__info-wrapper">
              <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
              <div class="go-cart-item__info">
                  <a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>
                  <div class="go-cart-item__variant"><span></span> ${itemVariant}</div>
                  <div class="go-cart-item__quantity">
                      <span class="go-cart-item__quantity-label">${this.labelQuantity} </span>
                      <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                      <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                      <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                  </div>
              </div>
          </div>
          <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
          <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
      </div>
    `;
          this.cartMiniCartContent.innerHTML += cartSingleProduct;
      });
      this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
      this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
      const removeFromCart = document.querySelectorAll(this.removeFromCart);
      removeFromCart.forEach((item) => {
          item.addEventListener('click', () => {
              GoCart.removeItemAnimation(item.parentNode);
              const line = item.parentNode.getAttribute('data-line');
              this.removeItem(line);
          });
      });
      const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
      itemQuantityPlus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
              this.changeItemQuantity(line, quantity);
          });
      });
      const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
      itemQuantityMinus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
              this.changeItemQuantity(line, quantity);
              if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                  GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode);
              }
          });
      });
  }

  renderBlankCartDrawer() {
      this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
      this.clearCartDrawer();
      this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;

      document.querySelectorAll('.js-go-cart-drawer .go-cart__button').forEach((element) => {
          element.classList.add('is-invisible');
      });
  }

  renderBlankMiniCart() {
      this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
      this.clearMiniCart();
      this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  reloadAjaxContent() {
    this.fetchAndOpenCart();
  }

  clearCartDrawer() {
      this.cartDrawerContent.innerHTML = '';
  }

  clearMiniCart() {
      this.cartMiniCartContent.innerHTML = '';
  }

  clearCartModal() {
      this.cartModalContent.innerHTML = '';
  }

  openCartDrawer() {
      this.cartDrawer.classList.add('is-open');
  }

  closeCartDrawer() {
      this.cartDrawer.classList.remove('is-open');
  }

  openMiniCart() {
      this.cartMiniCart.classList.add('is-open');
  }

  closeMiniCart() {
      this.cartMiniCart.classList.remove('is-open');
  }

  openFailModal() {
      this.cartModalFail.classList.add('is-open');
  }

  closeFailModal() {
      this.cartModalFail.classList.remove('is-open');
  }

  openCartModal() {
      this.cartModal.classList.add('is-open');
  }

  closeCartModal() {
      this.cartModal.classList.remove('is-open');
  }

  openCartOverlay() {
      this.cartOverlay.classList.add('is-open');
  }

  closeCartOverlay() {
      this.cartOverlay.classList.remove('is-open');
  }

  static removeItemAnimation(item) {
      item.classList.add('is-invisible');
  }

  setDrawerDirection() {
      this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
  }

}

//export default GoCart;

